  import React, { useState } from "react";



import MobileInput from "../components/ApplyNowSteps/AadhaarInput";

import OtpVerification from "../components/ApplyNowSteps/OtpVerification";

import AadharFulfill from "../components/ApplyNowSteps/AadharFulfill";

import LoanForm from "../components/ApplyNowSteps/LoanForm";

import ThankYou from "../components/ApplyNowSteps/ThankYou";   // <-- ADD THIS



import "../pages/ApplyNow.css";



const ApplyNow = () => {

  const [step, setStep] = useState(1);

  const [mobileNumber, setMobileNumber] = useState("");

  const [consent, setConsent] = useState(false);

  const [otp, setOtp] = useState("");



  return (

    <div className="apply-now-page d-flex justify-content-center align-items-center">

      <div className="apply-now-card">


        {/* STEP 1 : Mobile Number Input */}

        {step === 1 && (

          <MobileInput

            mobileNumber={mobileNumber}

            setMobileNumber={setMobileNumber}

            consent={consent}

            setConsent={setConsent}

            onNext={() => setStep(2)}

          />

        )}



        {/* STEP 2 : OTP Verification */}

        {step === 2 && (

          <OtpVerification

            mobileNumber={mobileNumber}

            otp={otp}

            setOtp={setOtp}

            onBack={() => setStep(1)}

            // onVerify will receive the response body from the proxy (response.data)

            onVerify={(verifyResponse) => {

              // verifyResponse shape can be { data: {...}, responseMessage, responseCode }

              // Consider it successful if it contains `data` or indicates success in the message/code.

              const msg = verifyResponse?.responseMessage || '';

              const code = verifyResponse?.responseCode || '';

              const hasData = !!verifyResponse?.data;

              const looksSuccessful = hasData || /success/i.test(msg) || /mock200/i.test(code) || /^S/.test(code);

              if (looksSuccessful) {

                setStep(3);

              } else {

                // Show server-provided message when possible, otherwise a generic hint

                alert(verifyResponse?.responseMessage || 'Invalid OTP.');

              }

            }}

          />

        )}



        {/* STEP 3 : Aadhaar Autofill */}

        {step === 3 && (

          <AadharFulfill

            onBack={() => setStep(2)}

            onNext={() => setStep(4)}

          />

        )}



        {/* STEP 4 : Loan Form */}

        {step === 4 && (

          <LoanForm

            onBack={() => setStep(3)}

            onNext={() => setStep(5)}   // <-- GO TO THANK YOU PAGE

          />

        )}



        {/* STEP 5 : THANK YOU PAGE */}

        {step === 5 && <ThankYou />}

      </div>

    </div>

  );

};



export default ApplyNow;

